import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton, Drawer } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getMonthName } from "../../../../utils/getMonthName";
import DocumentItem from "../../../../Components/Masters/DocumentItem";
import { truncateNumber } from "../../../../utils/common";
import { useUser } from "../../../../context/AuthContext";
function ViewOffRoad({ data, viewData, setViewData, handleEdit }) {
  const [filteredData, setFilteredData] = useState({});

  useEffect(() => {
    if (data) {
      setFilteredData(data);
    }
  }, [data]);
  const { user } = useUser();

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "410px",
        maxWidth: "100%",
        height: "100vh",
        justifyContent: "space-between",
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={() => setViewData(false)} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{ p: 3, width: "100%", backgroundColor: "#fff", overflow: "auto" }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",
            mb: 2,
          }}
        >
          Off Road Vehicle and Equipment Details
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            mb: 1,
            width: "100%",
          }}
        >
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
              Date
            </Typography>

            <Typography sx={{ mb: 1 }}>
              {new Date(data?.createdAt).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              }) ?? ""}
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Consumption Month
            </Typography>
            <Typography sx={{ mb: 1 }}>
              {data?.consumptionPeriod === "" || undefined
                ? "-"
                : `${getMonthName(data?.consumptionPeriod?.month)} ${
                    data?.consumptionPeriod?.year
                  }` ?? "-"}
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Category of Machinery
            </Typography>

            <Typography sx={{ mb: 1 }}>
              {data?.machineryCategory ?? ""}
            </Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Machinery Type
            </Typography>

            <Typography sx={{ mb: 1 }}>{data?.machineryType?.name}</Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Machinery Name
            </Typography>

            <Typography sx={{ mb: 1 }}>
              {data?.machineryName?.name ?? ""}
            </Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Fuel Type
            </Typography>

            <Typography sx={{ mb: 1 }}>{data?.fuelType ?? "-"}</Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Fuel Consumed
            </Typography>

            <Typography sx={{ mb: 1 }}>
              {truncateNumber(data?.fuelConsumed.value) ?? "-"} {data?.fuelConsumed.unit}
            </Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Type of Entry
            </Typography>

            <Typography sx={{ mb: 1 }}>{data?.typeOfEntry ?? "-"}</Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Hours Used (optional)
            </Typography>

            <Typography sx={{ mb: 1 }}>{truncateNumber(data?.usedhours) ?? "-"}</Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Remark (optional)
            </Typography>
            <Typography sx={{ mb: 1 }}>
              {data?.remarks === "" || undefined ? "-" : data?.remarks ?? "-"}
            </Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 2 }}>
              Documents (optional)
            </Typography>

            <Box
              display="flex"
              flexDirection="column"
              gap={1}
              sx={{ mt: 2, width: "100%" }}
            >
              {/* Render Images First */}
              {data && data.documents.length > 0 && (
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {data.documents
                    .filter((url) =>
                      ["png", "jpg", "jpeg"].includes(
                        url.split(".").pop().toLowerCase()
                      )
                    )
                    .map((url, index) => (
                      <DocumentItem key={`image-${index}`} url={url} />
                    ))}
                </Box>
              )}

              {/* Render Other Documents */}
              {data && data.documents.length > 0 ? (
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {data.documents
                    .filter(
                      (url) =>
                        !["png", "jpg", "jpeg"].includes(
                          url.split(".").pop().toLowerCase()
                        )
                    )
                    .map((url, index) => (
                      <DocumentItem key={`file-${index}`} url={url} />
                    ))}
                </Box>
              ) : (
                "-"
              )}
            </Box>
          </Box>
        </Box>
        {!user?.companyAdmin && (<Button
          variant="contained"
          sx={{ mt: 2, backgroundColor: "#0a3f73", textTransform: "none" }}
          onClick={handleEdit}
        >
          Edit
        </Button>)}
      </Box>
    </Box>
  );

  return (
    <Drawer
      anchor="right"
      open={viewData}
      onClose={() => setViewData(false)}
      sx={{
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      {list()}
    </Drawer>
  );
}

export default ViewOffRoad;
